import React from "react";
import { Navigate } from "react-router-dom";
//import Home from "../pages/home/Dashboard";
//import Login from "../pages/AuthenticationPages/Login"
import Page from "@jumbo/shared/Page";
import HomeRoutes from "./Homeroutes";
import AudienceRoutes from "./AudienceRoutes";
import ConsentRoutes from "./ConsentRoutes";
import AuthRoutes from "./AuthRoutes";
import Login from "app/pages/AuthenticationPages/Login";
import SystemRoutes from "./SystemRoutes";
import AdvertiserRoutes from "./AdvertiserRoutes";
import AudiencePixelRoutes from "./AudiencePixelRoutes";
import { getAuthToken } from "@jumbo/services/auth/jwtAuth";
//const auth = getAuthToken() != null ? true : null;
const auth = localStorage.getItem("access_token") != null ? true : null;

console.log("Auth:", auth);
/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/
const routesForPublic = [
  {
    path: "/",
    element: auth ? (
      <Navigate to="/home/dashboard" />
    ) : (
      <Page component={Login} layout={"solo-page"} />
    ),
  },
];

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
  {
    path: "/",
    element: auth ? (
      <Navigate to="/home/dashboard" />
    ) : (
      <Page component={Login} layout={"solo-page"} />
    ),
  },
  ...HomeRoutes,
  ...AudienceRoutes,
  ...ConsentRoutes,
  ...AuthRoutes,
  ...SystemRoutes,
  ...AdvertiserRoutes,
  ...AudiencePixelRoutes,
  {
    path: "*",
    element: auth ? (
      <Navigate to="/home/dashboard" />
    ) : (
      <Page component={Login} layout={"solo-page"} />
    ),
  },
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [];

const routes = [
  ...routesForPublic,
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
];

export {
  routes as default,
  routesForPublic,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
};
